import React from 'react'

import Layout from '../components/Layout'
import {Posts} from '../components/Main'

const Videos = ({ location }) => {
    return (
        <Layout location={location}>
            <Posts pageTitle={'Videos'} category={['videos']} />
        </Layout>
    )
}

export default Videos
